export default __webpack_public_path__ + "static/media/git.94562587.svg";